import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { useReveal, Seo } from "@/lib/seo";
import { api, mediaUrl } from "@/lib/api";
import { BLOG_CATEGORIES } from "@/lib/data";
import { useSiteImage } from "@/context/ContentContext";

export default function Blog() {
  useReveal();
  const img = useSiteImage();
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  const catLabel = (v) => BLOG_CATEGORIES.find((c) => c.value === v)?.label || v;

  return (
    <div data-testid="blog-page">
      <Seo title="Le Journal Afro Regal — Blog art de recevoir & événementiel" description="Conseils, inspirations et coulisses : mariages, événements professionnels, catering et art de recevoir par Afro Regal." />
      <PageHero eyebrow="Le Journal Afro Regal" title="Inspirations & art de recevoir" image={img("blog_hero")} />
      <section className="py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          {posts.length === 0 ? (
            <p className="py-16 text-center text-[#2C2C2C]/60" data-testid="blog-empty">Les premiers articles du Journal arrivent bientôt.</p>
          ) : (
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {posts.map((p) => (
                <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="reveal group overflow-hidden rounded-2xl border border-[#2C2C2C]/10 bg-white transition-shadow hover:shadow-xl">
                  <div className="h-48 overflow-hidden bg-[#2C2C2C]/5">
                    {p.cover_url && <img src={mediaUrl(p.cover_url)} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}
                  </div>
                  <div className="p-6">
                    <span className="text-xs uppercase tracking-wide text-[#C9A84C]">{catLabel(p.category)}</span>
                    <h3 className="mt-2 font-serif text-xl text-[#2C2C2C]">{p.title}</h3>
                    <p className="mt-2 line-clamp-3 text-sm text-[#2C2C2C]/65">{p.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-1 text-sm text-[#2C2C2C] group-hover:text-[#C9A84C]">Lire <ArrowRight size={14} /></span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
